import React from 'react'
import { Box, makeStyles, Typography } from '@material-ui/core'
import { CheckCircleOutlined as EnabledIcon, HighlightOffOutlined as DisabledIcon } from '@material-ui/icons'
import { green } from '@material-ui/core/colors'

import { IBusiness } from '../../../graphql/types/businesses'

interface IProps {
  business: IBusiness
}

export const BusinessNameColumn: React.FC<IProps> = ({ business }) => {
  return (
    <Box>
      <Typography variant='subtitle2'>{business.companyName}</Typography>

      <Box display='flex' alignItems='center'>
        <Box display='flex' alignItems='center'>
          <StatusIcon enabled={business.isBonusEnabled} />
          <Typography variant='body2' color='textSecondary' noWrap>
            {`Б: ${business.cashbackPercent}%`}
          </Typography>
        </Box>
        <Box mx={0.5}>
          <Typography color='textSecondary'>{' | '}</Typography>
        </Box>
        <Box display='flex' alignItems='center'>
          <StatusIcon enabled={business.isDiscountEnabled} />
          <Typography variant='body2' color='textSecondary' noWrap>
            {`С: ${business.discountPercent}%`}
          </Typography>
        </Box>
        <Box mx={0.5}>
          <Typography color='textSecondary'>{' | '}</Typography>
        </Box>
        {!!business.corpContract ? (
          <Box display='flex' alignItems='center'>
            <StatusIcon enabled={business.isCorpDiscountEnabled} />
            <Box color={green[500]}>
              <Typography variant='subtitle2' color='inherit' noWrap>
                {`КС: ${business.corpContract.discountPercent}%`}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Box display='flex' alignItems='center'>
            <StatusIcon enabled={business.isCorpDiscountEnabled} />
            <Typography variant='body2' color='textSecondary' noWrap>
              {`ЕКС: ${business.corpDiscountPercent}%`}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  )
}

const StatusIcon: React.FC<{ enabled: boolean }> = ({ enabled }) => {
  const classes = useStyles()

  return enabled ? (
    <Box color={green[500]} className={classes.icon}>
      <EnabledIcon color='inherit' className={classes.icon} />
    </Box>
  ) : (
    <DisabledIcon color='disabled' className={classes.icon} />
  )
}

const useStyles = makeStyles(theme => ({
  icon: {
    width: 16,
    height: 16,
    marginRight: 3,
  },
}))
